<template>
  <div class="box-summary">
    <div class="summary-item">
      下单金额: <app-locale-string :value="summary.sales_amount" />
    </div>
    <div class="summary-item">
      已收总额: <app-locale-string :value="summary.received_amount" />
    </div>
    <div class="summary-item">
      应收总额: <app-locale-string :value="summary.receivable_amount" />
    </div>
    <div class="summary-item">
      应收余额: <app-locale-string :value="summary.unreceived_receivable_amount" />
    </div>
    <div class="summary-item">
      订单余额: <app-locale-string :value="summary.sales_amount - summary.jushuitan_orders_amount" />
    </div>
    <div class="summary-item">
      毛利总额: <app-locale-string :value="summary.profit" />
    </div>
    <div class="summary-item">
      聚水潭订单总额: <app-locale-string :value="summary.jushuitan_orders_amount" />
    </div>
    <div class="summary-item">
      聚水潭订单运费: <app-locale-string :value="summary.jushuitan_orders_real_freight" />
    </div>
    <div class="summary-item">
      成本总额: <app-locale-string :value="summary.cost" />
    </div>
    <div class="summary-item">
      聚水潭退款总额: <app-locale-string :value="summary.jushuitan_after_sales_amount" />
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SalesOrderSummary extends Vue {
  @Prop({ type: Object, default: () => ({}) }) summary;
}
</script>

<style lang="scss" scoped>
.box-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 30px;
  color: $primary;
  font-weight: bold;
  padding-top: 10px;
  font-size: 14px;
}
</style>
